import { FC } from 'react';

import 'twin.macro';
import 'styled-components/macro';
import { Icon } from '../icon/Icon';
import { TextBadge } from './Badge';

export const LevelBadge: FC = ({ children, ...props }) => (
  <TextBadge {...props}>
    <Icon name="experience-level" tw="mr-1 text-3xl text-current font-normal" />
    {children}
  </TextBadge>
);
